import React from "react";
import { Select } from "antd";
import ButtonSection from "./ButtonSection";
import { useDispatch, useSelector } from "react-redux";
import {
  limitationCategoryFetch,
  oppFetch,
  organizationFetch,
  potentialFetch,
  sectorFetch,
  selectLicenseList,
  setSectors,
  subSectorClear,
  subSectorFetch,
} from "../../api/redux";
import { Formik } from "formik";
import { searchLog } from "../../api/crud";

const { Option, OptGroup } = Select;

export default (props) => {
  const state = useSelector(selectLicenseList);
  const [vals, setVals] = React.useState({});

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(sectorFetch());
    dispatch(limitationCategoryFetch());
    dispatch(organizationFetch());
  }, []);

  const sectorChangeHandler = (e, a) => {
    const params = { sectorId: a.value };
    dispatch(subSectorFetch(params));
  };

  const clearHandler = (func) => {
    func("sectorId", null);
    func("subSectorId", null);
    func("organizationId", null);
    dispatch(subSectorClear(null));

    dispatch(oppFetch());
    dispatch(potentialFetch());
  };

  return (
    <section className="d-flex flex-column gap-15">
      {vals && (
        <Formik
          enableReinitialize
          initialValues={vals}
          onSubmit={(values) => {
            dispatch(oppFetch(values));
            if (values.sectorId) {
              searchLog({ sectorId: values.sectorId });
            }
            dispatch(potentialFetch(values));
          }}
          onReset={() => {}}
        >
          {({ handleSubmit, setFieldValue, values }) => {
            return (
              <>
                {" "}
                <div className="col-12">
                  <Select
                    size={"large"}
                    showSearch
                    filterOption={(input, option) =>
                      option.children.toLowerCase().match(input.toLowerCase())
                    }
                    className="w-100 search-fields"
                    placeholder="انتخاب بخش"
                    onSelect={(e, a) => {
                      sectorChangeHandler(e, a);
                      setFieldValue("sectorId", e);
                    }}
                    allowClear
                    onClear={(e) => {
                      setFieldValue("subSectorId", null);
                      setFieldValue("sectorId", null);
                      dispatch(subSectorClear(null));
                    }}
                    direction="rtl"
                    showArrow={true}
                    value={values?.sectorId}
                    key={5}
                  >
                    {state.sectors &&
                      state.sectors.map((el) => {
                        return (
                          <Option className="text-right" value={el.id}>
                            {el.title}
                          </Option>
                        );
                      })}
                  </Select>
                </div>
                <div className="col-12">
                  <Select
                    className="w-100 search-fields"
                    size="large"
                    placeholder={"انتخاب زیربخش"}
                    showArrow={true}
                    direction="rtl"
                    showSearch
                    filterOption={(input, option) =>
                      option.children.toLowerCase().match(input.toLowerCase())
                    }
                    allowClear
                    key={6}
                    value={values?.subSectorId}
                    onSelect={(e) => {
                      setFieldValue("subSectorId", e);
                    }}
                    onClear={(e) => {
                      setFieldValue("subSectorId", null);
                    }}
                  >
                    {state.subSectors &&
                      state.subSectors.map((el) => {
                        return (
                          <Option className="text-right" value={el.id}>
                            {el.title}
                          </Option>
                        );
                      })}
                  </Select>
                </div>
                <div className="col-12">
                  <Select
                    className="w-100 search-fields"
                    size="large"
                    placeholder={"انتخاب سازمان"}
                    showArrow={true}
                    direction="rtl"
                    key={7}
                    showSearch
                    filterOption={(input, option) =>
                      option.children.toLowerCase().match(input.toLowerCase())
                    }
                    allowClear
                    value={values?.organizationId}
                    onSelect={(e, a) => {
                      setFieldValue("organizationId", e);
                    }}
                    onClear={(e) => {
                      setFieldValue("organizationId", null);
                    }}
                  >
                    {state.organizations &&
                      state.organizations.map((el) => {
                        return (
                          <Option className="text-right" value={el.id}>
                            {el.title}
                          </Option>
                        );
                      })}
                  </Select>
                </div>
                <ButtonSection
                  submitHandler={handleSubmit}
                  clearHandler={clearHandler}
                  func={setFieldValue}
                />
              </>
            );
          }}
        </Formik>
      )}
    </section>
  );
};
